import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';

const CompileAndDeployComponent = (props) => {
    const [response, setResponse] = useState('');
    const [_ContractName, set_ContractName] = useState('');
    const [_ContractSymbol, set_ContractSymbol] = useState('');
    const [_TotalSupply, set_TotalSupply] = useState('');
    const [_TokenTransferAddress, set_TokenTransferAddress] = useState('');
    const userAddress = props.userAddress;
    const getLastPaymentRecordIndex = props.getLastPaymentRecordIndex;
    const _selectededNetwork = props._ChainID;
    const navigate = useNavigate();
    const [_Series, set_Series] = useState('');
    const [_OtraInformacion, set_OtraInformacion] = useState('');
    const [_RequisitosLegales, set_RequisitosLegales] = useState('');
    const [errorMessage, setErrorMessage] = useState(""); // State to hold error message
    const [errorMessage1, setErrorMessage1] = useState(""); // State to hold error message
    const [errorMessage2, setErrorMessage2] = useState(""); // State to hold error message
    const [errorMessage3, setErrorMessage3] = useState(""); // State to hold error message
    const [errorMessage4, setErrorMessage4] = useState(""); // State to hold error message

    
    useEffect(() => {
        console.log("_ChainID_USEEFFECT : " + _selectededNetwork);
    }, []);

    const handleCompileAndDeploy = async () => {
        try {
            // Trigger the compilation first
            const compileResponse = await axios.post('https://tokeniza.co.uk/api/compile');
            //http://localhost:3001/deploy

            console.log("compileResponse : " + compileResponse.data);

            if (compileResponse.data === 'Compilation successful' || compileResponse.data === 'Contracts are already compiled. Move to deployment') {
                console.log("Deploying....");
                setResponse("Deploying & Verifying....");

                console.log("chainID_CLIENT : " + _selectededNetwork);

                // If compilation is successful, trigger the deployment
                const deployResponse = await axios.post('https://tokeniza.co.uk/api/deploy', {
                    //http://localhost:3001/deploy

                    contractName: _ContractName,
                    series: _Series,
                    contractSymbol: _ContractSymbol,
                    totalSupply: _TotalSupply,
                    tokenTransferAddress: _TokenTransferAddress,
                    userAddress: userAddress,
                    otraInformacion: _OtraInformacion,
                    requisitosLegales: _RequisitosLegales,
                    getLastPaymentRecordIndex: Number(getLastPaymentRecordIndex),
                    selectededNetwork: _selectededNetwork

                });

                if (deployResponse.data === 'Deployment successful') {
                    setResponse('Contract deployed & verified successfully.');
                    await new Promise(resolve => setTimeout(resolve, 3000));
                    navigate(`/token-dashboard`);
                } else {
                    setResponse(`Error during deployment: ${deployResponse.data}`);
                }
            } else {
                setResponse(`Error during compilation: ${compileResponse.data}`);
            }

        } catch (error) {
            console.error('Error during compilation and deployment:', error.message);
            setResponse(`Error during compilation and deployment: ${error.message}`);
        }
    };

    const isButtonDisabled = !(_ContractName && _Series && _ContractSymbol && _TotalSupply && _TokenTransferAddress);

    return (

        <div>
            <div class="header">DEPLOY</div>
            <div class="registerT">Unlock the power of customization and create your unique token here, tailoring it to your preferences and needs with just a few simple clicks.</div>
            <div className='mainDiv'>

                <div>
                    <div>
                        <input
                            required
                            className="mintingAmount"
                            type="text"
                            name="_ContractName"
                            placeholder="Contract Name"
                            value={_ContractName}
                            onChange={event => {
                                const inputValue = event.target.value;
                                if (inputValue.length <= 10) {
                                    set_ContractName(inputValue);
                                    setErrorMessage(""); // Clear error message if length is valid
                                } else {
                                    setErrorMessage("Length exceeds maximum allowed (10 characters)"); // Set error message
                                }
                            }}
                        />
                        {/* Display error message if it's not empty */}
                        {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}

                        <input
                            required
                            className="mintingAmount"
                            type="text"
                            name="_Series"
                            placeholder="Series"
                            value={_Series}
                            onChange={event => {
                                const inputValue = event.target.value;
                                if (inputValue.length <= 10) {
                                    set_Series(inputValue);
                                    setErrorMessage1(""); // Clear error message if length is valid
                                } else {
                                    setErrorMessage1("Length exceeds maximum allowed (10 characters)"); // Set error message
                                }
                            }}
                        />
                        {/* Display error message if it's not empty */}
                        {errorMessage1 && <div style={{ color: 'red' }}>{errorMessage1}</div>}

                        <input
                            required
                            className="mintingAmount"
                            type="text"
                            name="_ContractSymbol"
                            placeholder="Contract Symbol"
                            value={_ContractSymbol}
                            onChange={event => {
                                const inputValue = event.target.value;
                                if (inputValue.length <= 10) {
                                    set_ContractSymbol(inputValue);
                                    setErrorMessage2(""); // Clear error message if length is valid
                                } else {
                                    setErrorMessage2("Length exceeds maximum allowed (10 characters)"); // Set error message
                                }
                            }}
                        />
                        {/* Display error message if it's not empty */}
                        {errorMessage2 && <div style={{ color: 'red' }}>{errorMessage2}</div>}
                    </div>
                    <div>
                        <input
                            required
                            className="mintingAmount"
                            type="number"
                            name="_TotalSupply"
                            placeholder="Total Supply"
                            value={_TotalSupply}
                            onChange={event => {
                                const inputValue = event.target.value;
                                if (inputValue <= 3000000000) { // 3 billion limit
                                    set_TotalSupply(inputValue);
                                    setErrorMessage4(""); // Clear error message if value is valid
                                } else {
                                    setErrorMessage4("Amount cannot exceed 3 billion"); // Set error message
                                }
                            }}
                        />
                        {/* Display error message if it's not empty */}
                        {errorMessage4 && <div style={{ color: 'red' }}>{errorMessage4}</div>}
                    </div>

                    <div>
                        <input
                            required
                            className="mintingAmount"
                            type="text"
                            name="_TokenTransferAddress"
                            placeholder="Token Transfer Address"
                            value={_TokenTransferAddress}
                            onChange={event => {
                                const inputValue = event.target.value;
                                if (inputValue.length <= 42) {
                                    set_TokenTransferAddress(inputValue);
                                    setErrorMessage3(""); // Clear error message if length is valid
                                } else {
                                    setErrorMessage3("Wallet address seems to be wrong"); // Set error message
                                }
                            }}
                        />
                        {/* Display error message if it's not empty */}
                        {errorMessage3 && <div style={{ color: 'red' }}>{errorMessage3}</div>}
                    </div>

                    <input name="_OtraInformacion" placeholder='Otra información' value={_OtraInformacion}
                        onChange={event => set_OtraInformacion(event.target.value)}></input>

                    <label class="mintingAmount2" for="multilineInput">Requisitos legales</label>
                    <div></div>
                    <textarea id="multilineInput" name="inputText" rows="70" placeholder="Type your text here..." value={_RequisitosLegales}
                        onChange={event => set_RequisitosLegales(event.target.value)}></textarea>
                </div>

                <button className='inButton' onClick={handleCompileAndDeploy} disabled={isButtonDisabled}>
                    Compile and Deploy Contract
                </button>
                <div className='note'>{response}</div>

            </div>
        </div >
    );
};

export default CompileAndDeployComponent;
